import styled, { css } from 'styled-components';

interface IRichTextContainerProps {
  color?: string;
  bold?: boolean;
}

export const RichTextContainer = styled.div<IRichTextContainerProps>`
  /* Base typography from Body4 */
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: ${({ theme, bold }) => bold ? theme.fontWeight.bold : theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.m};
  color: ${({ theme, color = 'oxfordBlue' }) => theme.colors[color]};
  line-height: ${({ theme }) => theme.lineHeight.lh4};

  /* Reset margins for first/last elements */
  & > *:first-child {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }

  /* Paragraph styling */
  p {
    margin: 0 0 ${({ theme }) => theme.spacing.m} 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  /* List styling */
  ul, ol {
    margin: 0 0 ${({ theme }) => theme.spacing.m} 0;
    padding-left: ${({ theme }) => theme.spacing.l};
  }

  li {
    margin-bottom: ${({ theme }) => theme.spacing.s};
  }

  /* Link styling */
  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  /* Strong/Bold */
  strong, b {
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  }

  /* Emphasis/Italic */
  em, i {
    font-style: italic;
  }

  /* Blockquote */
  blockquote {
    margin: ${({ theme }) => theme.spacing.m} 0;
    padding-left: ${({ theme }) => theme.spacing.m};
    border-left: 3px solid currentColor;
    opacity: 0.9;
  }

  /* Code */
  code {
    font-family: monospace;
    background-color: ${({ theme }) => theme.colors.antiFlashWhite};
    padding: ${({ theme }) => theme.spacing.xxs} ${({ theme }) => theme.spacing.xs};
    border-radius: ${({ theme }) => theme.radius.xs};
  }

  pre {
    margin: ${({ theme }) => theme.spacing.m} 0;
    padding: ${({ theme }) => theme.spacing.m};
    background-color: ${({ theme }) => theme.colors.antiFlashWhite};
    border-radius: ${({ theme }) => theme.radius.s};
    overflow-x: auto;

    code {
      background: none;
      padding: 0;
    }
  }
`;
